import { hooks } from '@adc/ui-core'

// exporting for backward compatibility
export default hooks.useWindowDimensions
